export default (state = [], action) => {
	switch (action.type) {
		case "ADD_METAFIELD_GROUP": {
			const newState = state.slice();
			newState.push(action.metafield_group);
			return newState;
		}
		case "UPDATE_METAFIELD_GROUP": {
			const newState = state.slice();
			for (let i = 0; i < newState.length; i++) {
				if (newState[i].id == action.metafield_group.id) {
					newState[i] = action.metafield_group;
				}
			}
			return newState;
		}
		case "REMOVE_METAFIELD_GROUP": {
			const newState = [];
			for (let i = 0; i < state.length; i++) {
				if (state[i].id != action.id) {
					newState.push(state[i]);
				}
			}
			return newState;
		}
		default:
			return state;
	}
};
